/**
 * @name VirtualKeyboardStateType
 * @description
 * Enum for the state of the virtual keyboard
 */
export var VirtualKeyboardStateType;
(function (VirtualKeyboardStateType) {
    VirtualKeyboardStateType["INACTIVE"] = "INACTIVE";
    VirtualKeyboardStateType["ACTIVE"] = "ACTIVE";
})(VirtualKeyboardStateType || (VirtualKeyboardStateType = {}));
/**
 * @name ButtonKeyboardStateType
 * @description
 * Enum for the state of the button keyboard
 */
export var ButtonKeyboardStateType;
(function (ButtonKeyboardStateType) {
    ButtonKeyboardStateType["DEFAULT"] = "DEFAULT";
    ButtonKeyboardStateType["PRESSED"] = "PRESSED";
})(ButtonKeyboardStateType || (ButtonKeyboardStateType = {}));
//# sourceMappingURL=state.js.map